import { mountComponentWithDataProps } from 'javascripts/shared/utils/react_mount';

import { PersonApp } from 'javascripts/apps/person_app';

mountComponentWithDataProps('#person-app', PersonApp);
